import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/[lang]/[...slug]/landingpage.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/[lang]/not-authorized.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/[lang]/not-found.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CookieCheck"] */ "/opt/build/repo/src/components/client/Breadcrumbs/CookieCheck.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/client/FeaturedResources/FormatFeaturedResources.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/client/FormatBlogSwitcher.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BlogDigestWrapper"] */ "/opt/build/repo/src/components/client/SectionBlogDigest/BlogDigestWrapper.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/components/client/TabbedResourceGrid/ResourceGrid.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/components/client/SectionBlogDigest/SectionBlogDigest.css");
;
import(/* webpackMode: "eager", webpackExports: ["TabbedResourceGrid"] */ "/opt/build/repo/src/components/client/TabbedResourceGrid/TabbedResourceGrid.tsx");
